import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;

/*
  FIRESTORE COLLECTIONS STRUCTURE:
  ─────────────────────────────────
  posts/
    {postId}
      - title: string
      - slug: string (url-friendly, e.g. "gold-outlook-q2-2025")
      - excerpt: string
      - content: string (HTML from rich text editor)
      - category: "macro-note" | "weekly-outlook" | "trade-idea" | "education" | "resource"
      - tags: array of strings
      - author: string
      - coverImage: string (Firebase Storage URL)
      - publishDate: timestamp
      - featured: boolean
      - status: "draft" | "published"
      - createdAt: timestamp
      - updatedAt: timestamp

  uploads/
    {uploadId}
      - name: string
      - url: string (Firebase Storage URL)
      - type: string (image/pdf/etc)
      - size: number
      - uploadedAt: timestamp

  newsletter/
    {emailId}
      - email: string
      - subscribedAt: timestamp
*/
